import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors } from '@opallabs/gem'
import { buttonSelectors } from '@opallabs/lapidary'

export const DatePickerStyleStates = {
  hasValue: 'has-value',
}
export const DatePickerStyleSelectors = {
  root: 'satellite-date-picker',
}

export const textDisplay = css({
  backgroundColor: gemVar(ThemedColors.Surface2),
  blockSize: Spacing.XS * 9,

  [`&.${DatePickerStyleStates.hasValue}`]: {
    backgroundColor: gemVar(ThemedColors.Surface1),
    borderColor: gemVar(ThemedColors.StrokeSecondary2),
  },

  [`.${buttonSelectors.buttonContents}`]: {
    inlineSize: '100%',
    justifyContent: 'space-between',
  },
})
